// extracted by mini-css-extract-plugin
export var scrollArea = "_nj-0";